import icon from 'vue-svgicon'
icon.register({
  'shenhe': {
    width: 1024,
    height: 1024,
    viewBox: '0 0 1024 1024',
    data: '<path d="M125.44 906.24h788.48c25.6-2.56 23.04 5.12 23.04-23.04V819.2c0-35.84-7.68-43.52-43.52-43.52h-153.6c-20.48-15.36-23.04-35.84-28.16-40.96-89.6-99.84-38.4-166.4 17.92-258.56 10.24-12.8 20.48-25.6 28.16-40.96 23.04-40.96 35.84-87.04 35.84-138.24C793.6 138.24 665.6 7.68 504.32 7.68c-158.72 0-289.28 128-289.28 289.28 0 66.56 23.04 128 61.44 176.64 61.44 97.28 161.28 176.64 0 302.08h-153.6c-28.16 0-43.52 15.36-43.52 43.52v66.56c0 25.6 17.92 20.48 46.08 20.48z m855.04 43.52H35.84c-12.8 0-23.04 10.24-23.04 23.04v23.04c0 12.8 10.24 23.04 23.04 23.04h942.08c12.8 0 23.04-10.24 23.04-23.04V972.8c0-12.8-10.24-23.04-20.48-23.04z" fill="" p-id="17727"></path>'
  }
})
